<script>
  import { fly } from "svelte/transition";
  import { tourFunctions } from "../tour-functions";
  import { createEventDispatcher } from 'svelte';
  import AiIcon from './icons/AiIcon.svelte';
  import i18n from './i18n/i18n';
  
  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('personalize');
    tourFunctions.focus();
  }
</script>

  <button
    transition:fly={{ y: 300, duration: 500 }}
    class="personalization-button"
    on:click={handleClick}
    aria-label={$i18n.t('tour.personalize')}
  >
    <div class="icon">
      <AiIcon color="white" />
    </div>
    <span class="personalization-button-text">
      {$i18n.t('tour.personalize')}
    </span>
  </button>

<style>
  .icon {
    width: 2em;
    height: 2em;
  }

  .personalization-button {
    position: absolute;
    z-index: 900;
    bottom: 5px;
    left: 5px;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-family: var(--font-body), sans-serif;
    font-weight: 700;
    line-height: 40px;
    color: white;
    background-color: transparent;
    /* padding: 3px 16px; */
    text-align: center;
    text-transform: uppercase;
    border-radius: 5px;
    border: none;
    text-decoration: none;
    font-size: 14px;
  }

  .personalization-button:hover {
    opacity: 0.8;
  }

  .personalization-button-text {
    font-weight: 700;
  }

  @media (max-width: 768px) {
    .personalization-button {
      font-size: 1em;
      /* padding: 3px 10px; */
      bottom: 10px;
      left: 10px;
    }
    
    .personalization-button-text {
      display: none;
    }
  }
</style> 